import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

import homekitLogo from '../../../homekit.svg';

export function Header() {
  return (
    <Navbar as="header" bg="homekit" sticky="top" variant="light">
      <Container className="justify-content-center">
        <Navbar.Brand as="span">
          <img src={homekitLogo} alt="HomeKit" height={50} />
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
}
